import React from 'react';

export function FloatingElements() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      <div className="floating-element w-96 h-96 -top-48 -left-48 opacity-30" 
           style={{ animationDelay: '0s' }} />
      <div className="floating-element w-96 h-96 -top-48 -right-48 opacity-30" 
           style={{ animationDelay: '2s' }} />
      <div className="floating-element w-96 h-96 -bottom-48 -left-48 opacity-30" 
           style={{ animationDelay: '4s' }} />
      <div className="floating-element w-96 h-96 -bottom-48 -right-48 opacity-30" 
           style={{ animationDelay: '6s' }} />
    </div>
  );
}